/**
 * FileName : websocket.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-10-08 10:33:24
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

import bus from 'src/utils/eventBus';
import moment from 'moment';

type SocketProperty = {
    onopen: any;
    onclose: any;
    close(code?: number, reason?: string): void;
    onerror: any;
    onmessage: any;
    send(data: any): void;
    parentAttr?: any;
    readyState: number;
};

type ConnectParams = {
    username: string;
}

type Params = {
    url?: string; // 链接地址
    timeout?: number; // 超时时间
    // 下面参数需要就使用，不得更改已有逻辑,可自行添加其他方法
    socketOpen?: Function;
    socketClose?: Function;
    socketError?: Function;
    params: ConnectParams
};

/**
 * websocket参数说明
 * @param {Params} params 其他参数
 */

class Socket {
    private url: string = window?.config?.webSocketUrl || '';
    private timeout: number = 30000;
    private socket: null | SocketProperty = null;
    private intervalTime: number = 8000;
    private isSucces: boolean = false;
    private taskRemindInterval: any = null;
    private params: any = {};
    private timerError: any = null;
    private isLogin: boolean = false;
    private FORMAT:string= 'YYYY-MM-DD HH:mm:ss';
    constructor (params: Params = {params: {username: ''}}) {
        this.url = `${params.url || this.url}/${params.params.username}` ;
        this.params = params;
        this.timeout = params.timeout || this.timeout;
    }
    connection () {
        try {
            if (!this.socket || this.socket.readyState !== 1) {
                this.socket = new WebSocket(this.url);
                this.socket.onopen = this.onOpen.bind(this);
                this.socket.onclose = this.onClose.bind(this);
                this.socket.onerror = this.onError.bind(this);
                this.socket.onmessage = this.onMessage.bind(this);
                this.isLogin = true;
            }
        } catch (error) {
            console.error('connection', error);
            this.onError(error);
        }
    }
    reconnect () {
        if (this.timeout) {
            this.timerError = setTimeout(() => {
                if (this.socket && this.socket.readyState !== 1 && this.isLogin) { // 连接失败
                    this.socket.close(); // 关闭连接
                    this.socket = null;
                    this.isSucces = false;
                    console.info(`${moment().format(this.FORMAT)}------reconnect----${this.isSucces}`);
                    this.connection(); // 重新连接
                }
                clearTimeout(this.timerError);
            }, this.timeout);
        } else {
            this.socket = null;
            this.isSucces = false;
            console.info(`${moment().format(this.FORMAT)}------reconnect-Error----${this.isSucces}`);
            clearTimeout(this.timerError);
        }
    }
    onOpen = () => {
        // 启动成功事件，并开启心跳
        const socketOpen = this.params?.socketOpen;

        this.isSucces = true;
        socketOpen && socketOpen();
        console.info(`${moment().format(this.FORMAT)}------onOpen----${this.isSucces}`);
        if (typeof this.heartCeck === 'function') {
            this.heartCeck();
        }
        bus.emit('onOpen');
    };
    onClose = (e?: any) => {
        // 关闭事件
        this.isSucces = false;
        console.info(`${moment().format(this.FORMAT)}------onClose----${this.isSucces}`);
        if (this.socket?.readyState === 1) {
            const socketClose = this.params?.socketClose;

            socketClose && socketClose(e);
            this.socket?.close();
        }
    };
    loginOut () {
        this.isSucces = false;
        this.isLogin = false;
        console.info(`${moment().format(this.FORMAT)}------loginOut----${this.isSucces}`);
        clearInterval(this.taskRemindInterval);
        if (this.socket?.readyState === 1) {
            const socketClose = this.params?.socketClose;

            socketClose && socketClose();
            this.socket?.close();
        }
    }
    onError = (e: any) => {
        // 异常事件
        let socketError = this.params?.socketError;

        this.isSucces = false;
        console.info(`${moment().format(this.FORMAT)}------onError----${this.isSucces}`);
        if (this.taskRemindInterval) {
            clearInterval(this.taskRemindInterval);
        }
        if (this.isLogin) {
            this.reconnect(); // 异常开启重连
        }
        socketError && socketError(e);
        console.error('onError', e);
        bus?.emit('error', e);
    };
    onMessage = (msg: any) => {
        // 接收消息，并ibus推送消息，某些业务模块需要对消息处理，则需要对返回消息名称进行判断，然后处理赋值给result
        let socketMessage = this.params?.socketMessage;

        socketMessage && socketMessage(msg.data);
        // 打印出后端推得数据
        if (typeof msg.data === 'string' && msg.data.includes('HeartBeat')) {
            return;
        }
        try {
            const row = JSON.parse(msg.data);

            if (row.code) {
                bus.emit(row.code, row.data);
            }
        } catch (error) {
            console.error('onMes-', error);
            this.onError(error);
        }
    };
    sendMessage (value: any) {
        // 发送消息
        if (this.socket && this.isSucces) {
            this.socket.send(value);
        } else {
            console.error('sendMes');
            this.onError('');
        }
    }
    heartCeck () {
        // 链接正常发送心跳
        this.taskRemindInterval = setInterval(() => {
            if (this.isSucces) {
                this.sendMessage('HeartBeat');
            } else {
                clearInterval(this.taskRemindInterval);
                console.error('heartCeck', this.isSucces);
                this.onError('');
            }
        }, this.intervalTime);
    }
}

export default Socket;
